// extracted by mini-css-extract-plugin
export default {"cardTitle":"General_cardTitle__4I7zO","vendorLogoWrapper":"General_vendorLogoWrapper__YRUpp"};